export const DEFAULT_SCROLLING_DOWN_OFFSET_TOP = 75;
export const SCROLLING_DOWN_HEADER_WITH_BANNER_OFFSET = 100;
